import { usePageTitle } from '../../hooks/usePageTitle';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import { Link } from 'react-router-dom';

// 静态定义文章列表
const articles = [
    {
        slug: 'jiaju',
        title: '家居',
        description: '家居设计与装修指南'
    },
    // 可以继续添加其他文章
];

export default function ArticlesPage() {
    usePageTitle('文章列表');
    const { i18n } = useTranslation();

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": i18n.language === 'zh' ? "文章列表 - Koluno" : "Articles - Koluno",
        "description": i18n.language === 'zh' ?
            "Koluno文章中心，为您提供各类精选内容和专业指南。" :
            "Koluno articles center, providing you with various selected content and professional guides.",
        "url": `${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/articles`,
        "publisher": {
            "@type": "Organization",
            "name": "Koluno"
        }
    };

    return (
        <div className="min-h-screen">
            <SEOHead
                title={i18n.language === 'zh' ? "文章列表 - Koluno" : "Articles - Koluno"}
                description={i18n.language === 'zh' ?
                    "Koluno文章中心，为您提供各类精选内容和专业指南。" :
                    "Koluno articles center, providing you with various selected content and professional guides."
                }
                keywords={i18n.language === 'zh' ?
                    "文章,内容,指南,专业知识,Koluno" :
                    "articles,content,guides,professional knowledge,Koluno"
                }
                ogTitle={i18n.language === 'zh' ? "文章列表 - Koluno" : "Articles - Koluno"}
                ogDescription={i18n.language === 'zh' ?
                    "Koluno文章中心，为您提供各类精选内容和专业指南。" :
                    "Koluno articles center, providing you with various selected content and professional guides."
                }
                ogUrl={`${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/articles`}
                structuredData={structuredData}
            />

            <Header />

            <main className="pt-24 pb-20">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                            {i18n.language === 'zh' ? '文章列表' : 'Articles'}
                        </h1>
                        <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto mb-8"></div>
                        <p className="text-xl text-gray-600">
                            {i18n.language === 'zh' ?
                                '探索我们的精选文章，获取有价值的信息和见解' :
                                'Explore our selected articles to gain valuable information and insights'
                            }
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-lg p-8 space-y-8">
                        <div className="space-y-6">
                            {articles.map((article) => (
                                <article key={article.slug} className="border-b border-gray-200 pb-6 last:border-b-0">
                                    <Link to={`/articles/${article.slug}`} className="block hover:opacity-80 transition-opacity">
                                        <h2 className="text-2xl font-bold text-gray-900 mb-2 hover:text-purple-600 transition-colors">
                                            {article.title}
                                        </h2>
                                        <p className="text-gray-600 mb-3">{article.description}</p>
                                        <span className="text-purple-600 font-medium text-sm">
                                            {i18n.language === 'zh' ? '阅读全文 →' : 'Read more →'}
                                        </span>
                                    </Link>
                                </article>
                            ))}
                        </div>

                        {articles.length === 0 && (
                            <div className="text-center py-12">
                                <p className="text-gray-500">
                                    {i18n.language === 'zh' ? '暂无文章' : 'No articles available'}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
